
var PurchaseOrders = (function (backOffice, $) {

    backOffice.PurchaseOrders = (function() {

        var scopeSelector = backOffice.options.scopeSelector;

        var initialise = function (options) {
            $.extend(backOffice.options, options);
            render();
            events();
        },

        render = function () {
            //  Do some DOM stuff
        },

        events = function () {


        },

        fetchProductsForPO = function(queryString, plu, poid, whid) {

            $.ajax(queryString, {method: 'POST'})
                .then(function(countCheckResponse) {
                    switch (countCheckResponse) {
                    case "-1":
                        document.getElementById('pluResponse').innerHTML = "<b>Error: Nothing entered!</b>";
                        return;
                    case "0":
                        document.getElementById('pluResponse').innerHTML =
                            "<b>Error: Product cannot be added to the Purchase Order as the PLU cannot be found</b>";
                        return;
                    }
                })
                .then(function() {
                    var url = `returnProd.asp?PLU=${plu}&poid=${poid}&WHID=${whid}`;
                    $.ajax(url, {method: 'POST'})
                        .then(function(response) {
                            document.getElementById('PLU').value = '';
                            document.getElementById('pluResponse').innerHTML = "";
                            return response;
                        }).then(function(prodHtml) {
                            var errorRegEx = new RegExp('^error', 'i');
                            if (errorRegEx.test(prodHtml)) {
                                document.getElementById('pluResponse').innerHTML = prodHtml;
                            } else {
                                $("#myModal .modal-body .modal-body-wrap", scopeSelector).html(prodHtml);
                                $("#myModal", scopeSelector).modal("show");
                                $("#myModal", scopeSelector).on("shown.bs.modal",
                                    function() {
                                        $("#myModal #Qty1", scopeSelector).val(0).select();
                                    });

                                var products = $("[data-product]", $(prodHtml));
                                if (products.length > 1) {
                                    var modalBodySelect = $("#myModal .modal-body select.product-selector", scopeSelector);
                                    modalBodySelect
                                        .find('option')
                                        .remove()
                                        .end()
                                        .append("<option value='all'>View All</option>");
                                    $("#myModal .modal-body .product-selector-container", scopeSelector).removeClass("hidden");
                                    for (var p = 0; p < products.length; p++) {
                                        var option = $("<option />"),
                                            productId = $(products[p]).attr("data-product");
                                        option.val(productId).text(productId);
                                        modalBodySelect.append(option);
                                    }
                                } else {
                                    $("#myModal .modal-body .product-selector-container", scopeSelector).addClass("hidden");
                                }

                            }
                        });

                });

        };


        //  Public API endpoints
        return {
            Init: initialise,
            FetchProductsForPO: fetchProductsForPO
        };

    })();

    return backOffice.PurchaseOrders;

})(BackOffice || {}, jQuery);